<ac-card sweepsVisible>
  <ac-card-content>
    <div class="redemption-dialog">
      <app-redemption-dialog-header
        [step]="0"
        title="Redeem"
        subtitle="Please enter the amount you'd like to redeem."
        [hideBack]="true"
        (close)="close.emit()"
      />

      <form
        class="redemption-dialog__input-box redemption-dialog__amount-input"
        #amountInputParent
        [formGroup]="redemptionMethodForm">
        <mat-form-field subscriptSizing="dynamic">
          <input
            formControlName="amount"
            #amountInput
            matInput
            (keydown)="amountKeydown($event)"
            (input)="onAmountInput($event)"
            [disabled]="hasPlaythroughRequirement()"
            placeholder="0"
            type="text"
          />
          @if (redemptionMethodForm.controls.amount.errors?.['min']) {
            <mat-error>Minimum {{ minimumRedemptionAmount.toFixed(2) }} SC</mat-error>
          } @else if (redemptionMethodForm.controls.amount.errors?.['maxBalance']) {
            <mat-error>Cannot redeem more than balance</mat-error>
          } @else if (redemptionMethodForm.controls.amount.errors?.['maxDailyLimit']) {
            <mat-error>Cannot redeem more than daily limit</mat-error>
          }
        </mat-form-field>
      </form>
      <ul class="redemption-dialog__button-list">
        <li>
          <button
            mat-flat-button
            class="redemption-dialog__button-list-button"
            (click)="select('crypto')"
            [style.opacity]="1"
            [style.display]="cryptoRedemptionEnabled() ? 'flex' : 'none'"
            [disabled]="
              !cryptoRedemptionEnabled() || hasPlaythroughRequirement() || (!!redemptionMethodForm.controls.amount.value && !redemptionMethodForm.valid)
            ">
            <div class="redemption-dialog__button-list-button-icon">
              <ac-icon iconKey="currency:usdc_circle" [size]="38" />
            </div>
            <div class="redemption-dialog__button-list-button-contents">
              <div class="ac-title-lg">Crypto</div>
              <div class="ac-body-sm redemption-dialog__button-list-button-subtitle">USDC</div>
            </div>
            <div>
              <ac-icon iconKey="hr:chevron_right" [size]="12" />
            </div>
          </button>
        </li>
        @if (!coinflowHidden() && coinflowUnavailableNotice(); as notice) {
          <li>
            <div class="redemption-dialog__error-box">
              <ac-icon iconKey="payment:warning" [size]="24" />
              <div>
                <div class="ac-title-sm">{{ notice.title }}</div>
                <div class="ac-body-sm">{{ notice.body }}</div>
              </div>
            </div>
          </li>
        }
        <li>
          <button
            mat-flat-button
            class="redemption-dialog__button-list-button ac-neutral"
            (click)="select('standard')"
            [style.opacity]="coinflowUnavailableNotice() ? 0.5 : 1"
            [style.display]="!coinflowHidden() ? 'flex' : 'none'"
            [disabled]="coinflowDisabled() || hasPlaythroughRequirement() || (!!redemptionMethodForm.controls.amount.value && !redemptionMethodForm.valid)">
            <div class="redemption-dialog__button-list-button-icon">
              <ac-icon iconKey="payment:bank_account_circle" [size]="38" />
            </div>
            <div class="redemption-dialog__button-list-button-contents">
              <div class="ac-title-lg">Bank Transfer</div>
              <div class="ac-body-sm redemption-dialog__button-list-button-subtitle">
                ACH, Debit Card
              </div>
            </div>
            <div class="ac-flex ac-gap-lg ac-algn-ctr">
              @if (coinflowStatusPending()) {
                <div class="redemption-dialog__pill redemption-dialog__pill--blocked"
                  [style.width.px]="107"
                  [style.height.px]="25"
                  [style.padding.px]="0">
                  KYC Pending
                </div>
              }
              <ac-icon iconKey="hr:chevron_right" [size]="12" />
            </div>
          </button>
        </li>
        <li [hideOnCasinoSettingDisabled]="'RedemptionsFiatVenmo'">
          <button
            mat-flat-button
            class="redemption-dialog__button-list-button ac-neutral"
            (click)="select('venmo')"
            [style.opacity]="coinflowUnavailableNotice() ? 0.5 : 1"
            [style.display]="!coinflowHidden() ? 'flex' : 'none'"
            [disabled]="coinflowDisabled() || hasPlaythroughRequirement() || (!!redemptionMethodForm.controls.amount.value && !redemptionMethodForm.valid)">
            <div class="redemption-dialog__button-list-button-icon">
              <ac-icon iconKey="payment:venmo_circle" [size]="38" />
            </div>
            <div class="redemption-dialog__button-list-button-contents">
              <div class="ac-flex ac-algn-ctr ac-gap-xs">
                <div class="ac-title-lg">Venmo</div>
                @if (venmoConnected()) {
                  <div
                    class="redemption-dialog__pill redemption-dialog__pill--complete ac-title-sm"
                    [style.width.px]="78"
                    [style.height.px]="18"
                    [style.padding.px]="0">
                    Connected
                  </div>
                }
              </div>
              <div
                class="ac-body-sm redemption-dialog__button-list-button-subtitle">
                Redeem directly to your Venmo account
              </div>
            </div>
            <div class="ac-flex ac-gap-lg ac-algn-ctr">
              @if (coinflowStatusPending()) {
                <div class="redemption-dialog__pill redemption-dialog__pill--blocked"
                  [style.width.px]="107"
                  [style.height.px]="25"
                  [style.padding.px]="0">
                  KYC Pending
                </div>
              }
              <ac-icon iconKey="hr:chevron_right" [size]="12" />
            </div>
          </button>
        </li>
      </ul>
      @if (hasPlaythroughRequirement()) {
        <div class="redemption-dialog__footer ac-body-sm text-warning">
          Due to a recent purchase, your Playthrough Requirement has changed.
          Please refresh the page.
        </div>
      }

      <div class="redemption-dialog__footer ac-body-sm">
        {{ minimumRedemptionAmount.toFixed(2) }} SC minimum redemption.
      </div>
    </div>
  </ac-card-content>
</ac-card>
